import styles from "./camera-order-item.module.css";

import { ReactComponent as DragIcon } from "../../../../../../components/svg/drag-icon.svg";
import { useRef } from "react";

export interface CameraOderItemProps {
    id: string;
    cameraName: string;
    dragged?: boolean;
    onDragStart?(): void;
    onDragEnd?(): void;
}

function CameraOrderItem(props: CameraOderItemProps) {
    const mainRef = useRef<any>(null);

    const render = () => {
        const cameraName = props.dragged ? "" : props.cameraName;

        return (
            <div
                ref={mainRef}
                id={props.id}
                className={styles["camera-order-item"]}
                onDragStart={(e) => {
                    e.stopPropagation();
                    if (props.onDragStart) props.onDragStart();
                }}
                onDragEnd={(e) => {
                    e.stopPropagation();
                    if (props.onDragEnd) props.onDragEnd();
                }}
            >
                <div className={styles["left"]}>
                    <div className={styles["camera-name"]}>{cameraName}</div>
                </div>
                <div
                    onMouseEnter={() => {
                        mainRef.current.setAttribute("draggable", true);
                    }}
                    onMouseLeave={() => {
                        mainRef.current.setAttribute("draggable", false);
                    }}
                    onTouchStart={() => {
                        mainRef.current.setAttribute("draggable", true);
                    }}
                    onTouchEnd={() => {
                        mainRef.current.setAttribute("draggable", false);
                    }}
                    className={styles["right"]}
                >
                    {!props.dragged && <DragIcon />}
                </div>
            </div>
        );
    };

    return render();
}

export default CameraOrderItem;
